import { render, staticRenderFns } from "./tableRecord.vue?vue&type=template&id=55f6b135&scoped=true&"
import script from "./tableRecord.vue?vue&type=script&lang=js&"
export * from "./tableRecord.vue?vue&type=script&lang=js&"
import style0 from "./tableRecord.vue?vue&type=style&index=0&id=55f6b135&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f6b135",
  null
  
)

export default component.exports